import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {TextField,} from 'redux-form-material-ui';
import {editCard, putCards} from "store/cards/actions";
import {checkRequiredFields} from "../../forms";
import {reduxForm, Field} from "redux-form";
import {translate} from "react-i18next";


class CardChangeForm extends Component {

    saveRef = ref => (this.firstInputRef = ref);

    render() {
        return (
            <form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <Field maxLength={100} name="f_word" component={TextField} hintText={this.props.foreignLang.name} style={{marginRight: '10px'}}/><br/>
                <Field maxLength={100} name="n_word" component={TextField} hintText={this.props.nativeLang.name} style={{marginRight: '10px'}} ref={this.saveRef} withRef/><br/>
                <Field maxLength={300} name="example" component={TextField} hintText={this.props.t('package_management_example_sentence')} style={{marginRight: '10px', verticalAlign: 'top'}}/>
                <div style={{textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px'}}>
                    {this.props.actions}
                </div>
            </form>
        )
    }

}

CardChangeForm = reduxForm({
    form: 'cardChangeForm',
})(translate()(CardChangeForm));

class CardChangeDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClose = () => {
        this.setState({open: false});
    };


    sendForm = (values) => {
        checkRequiredFields(['n_word', 'f_word'], values);
        return (dispatch, getState) => {
            this.handleClose();
            dispatch(editCard(this.props.card, values));
            return dispatch(putCards());
        }
    };

    submitForm = (values, dispatch) => {
        return dispatch(this.sendForm(values));
    };

    render() {
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                onClick={this.handleClose}
                key="cancel"
            />,
            <FlatButton
                label={this.props.t('dialog_save')}
                primary={true}
                type='submit'
                key="submit"
                keyboardFocused={true}
            />,
        ];
        const Wrapper = this.props.wrapper;
        return (
            <Wrapper {...this.props.wrapperProps} onClick={this.handleOpen}>
                edit
                <Dialog autoScrollBodyContent={true} open={this.state.open} title={this.props.t('package_management_edit_word')}>
                    <CardChangeForm
                        nativeLang={this.props.nativeLang}
                        foreignLang={this.props.foreignLang}
                        initialValues={this.props.card}
                        actions={actions}
                        onSubmit={this.submitForm}
                    />

                </Dialog>
            </Wrapper>
        )
    }
}

export default translate()(CardChangeDialog);



// WEBPACK FOOTER //
// ./src/components/packages/CardChangeDialog.js